import React, { useEffect, useState } from "react";
import axios from "axios";
import { Grid } from "@material-ui/core";
import MemeCard from "../components/MemeCard";

const MEME_URL = "https://api.imgflip.com/get_memes";

const Home = () => {
  const [memes, setmemes] = useState([]);
  useEffect(() => {
    async function loadApi() {
      const memes = await axios.get(MEME_URL);
      setmemes(memes.data.data.memes);
    }
    loadApi();
  }, []);
  return (
    <>
      <Grid container>
        {memes !== undefined &&
          memes.map((item, index) => {
            return <MemeCard meme={item} key={index} />;
          })}
      </Grid>
    </>
  );
};

export default Home;
